import { Component, Input, OnInit } from '@angular/core';
import { CART_ITEM_TYPE_PRODUCT, CartItem, SampleServiceItem, SupplyItem } from '@app/model/cart.model';

@Component({
    selector: 'app-sidebar-cart-item',
    templateUrl: './sidebar-cart-item.component.html',
    styleUrls: ['./sidebar-cart-item.component.scss']
})
export class SidebarCartItemComponent implements OnInit {

    @Input() cartItem: CartItem;
    @Input() isSamplingSupplyGroup: boolean;

    constructor() { }

    ngOnInit() {
    }

    isProductType() {
        return this.cartItem.resourceType === CART_ITEM_TYPE_PRODUCT;
    }

    isPrepServiceItem() {
        return this.cartItem instanceof SampleServiceItem;
    }

    isSamplingSupplyItem() {
        return this.cartItem instanceof SupplyItem;
    }

    hasIcon() {
        return !this.isPrepServiceItem();
    }
}
